var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[(_vm.newStore)?[_c('create-store',{attrs:{"storeData":_vm.storeData},on:{"alert":function($event){return _vm.alert($event)}}})]:[_c('edit-store',{attrs:{"storeData":_vm.storeData,"loading":_vm.loading},on:{"alert":function($event){return _vm.alert($event)}}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79422ab0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Accounting/StoreSingle.vue
// module id = null
// module chunks = 